/* Vloerenplaats — gewenste datum in de winkelwagen
   Werkt ook nadat Dawn de winkelwagen opnieuw opbouwt. */
(function () {
  var ATTR = 'Gewenste datum';
  var DAY = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var MON = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var VISIBLE = 5;
  var TOTAL = 15;
  var FIRST_AFTER_WORKDAYS = 5;

  /* Hoe ver vooruit een klant via "Andere datum kiezen" mag kiezen (in weken).
     Pas dit getal aan na overleg met de eigenaar. */
  var MAX_WEEKS_AHEAD = 12;

  function isWeekday(d) {
    var x = d.getDay();
    return x !== 0 && x !== 6;
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function addWorkdays(date, n) {
    var r = startOfDay(date);
    var added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      if (isWeekday(r)) added++;
    }
    return r;
  }

  function workdayList(start, count) {
    var out = [];
    var c = new Date(start);
    while (out.length < count) {
      if (isWeekday(c)) out.push(new Date(c));
      c.setDate(c.getDate() + 1);
    }
    return out;
  }

  function shortLabel(d) { return DAY[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  function longValue(d) { return d.getDate() + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear(); }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function toISO(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  function fromISO(s) {
    var p = (s || '').split('-');
    if (p.length !== 3) return null;
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(d.getTime()) ? null : d;
  }

  function fromLong(s) {
    var p = (s || '').trim().split(/\s+/);
    if (p.length !== 3) return null;
    var m = MON.indexOf(p[1]);
    if (m < 0) return null;
    var d = new Date(+p[2], m, +p[0]);
    return isNaN(d.getTime()) ? null : d;
  }

  function saveToCart(value) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { attributes: {} };
    body.attributes[ATTR] = value;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  function init(el) {
    if (el.dataset.vpInit) return;
    el.dataset.vpInit = '1';

    var list = el.querySelector('.vp-date-picker__list');
    var more = el.querySelector('.vp-date-picker__more');
    var input = el.querySelector('.vp-date-picker__input');
    var other = el.querySelector('.vp-date-picker__other-input');
    var hint = el.querySelector('.vp-date-picker__hint');
    if (!list || !more || !input) return;

    var first = addWorkdays(new Date(), FIRST_AFTER_WORKDAYS);
    var last = startOfDay(new Date());
    last.setDate(last.getDate() + MAX_WEEKS_AHEAD * 7);

    var dates = workdayList(first, TOTAL);
    var values = dates.map(longValue);
    var hintText = 'Alleen werkdagen, uiterlijk ' + longValue(last) + '.';

    function inRange(d) {
      return !!d && d >= first && d <= last && isWeekday(d);
    }

    function setHint(text, isError) {
      if (!hint) return;
      hint.textContent = text;
      hint.style.color = isError ? '#A23829' : '#8C8577';
    }

    // Eerder gekozen datum uit de winkelwagen; verlopen of ongeldige datums vervallen.
    var current = input.value;
    if (!inRange(fromLong(current))) current = '';
    var expanded = current ? values.indexOf(current) >= VISIBLE : false;

    function highlight(value) {
      list.querySelectorAll('button').forEach(function (b) {
        var on = b.dataset.dateValue === value;
        b.style.background = on ? '#1B1815' : '#FBF8F1';
        b.style.color = on ? '#F3EEE3' : '#1B1815';
      });
    }

    // source: 'button', 'calendar' of 'init'
    function select(value, persist, source) {
      input.value = value;
      highlight(value);
      if (other) {
        if (source === 'button') {
          other.value = '';
        } else if (source === 'init') {
          var d = fromLong(value);
          other.value = (values.indexOf(value) === -1 && d) ? toISO(d) : '';
        }
      }
      setHint(hintText, false);
      if (persist) saveToCart(value);
    }

    function render() {
      list.innerHTML = '';
      (expanded ? dates : dates.slice(0, VISIBLE)).forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = shortLabel(d);
        b.dataset.dateValue = longValue(d);
        b.style.cssText = 'border:1.5px solid #1B1815; background:#FBF8F1; color:#1B1815; font-family:IBM Plex Sans,sans-serif; font-size:12px; padding:7px 10px; cursor:pointer;';
        b.addEventListener('click', function () { select(b.dataset.dateValue, true, 'button'); });
        list.appendChild(b);
      });
      more.style.display = expanded ? 'none' : '';
    }

    render();
    // Geen geldige keuze bewaard? Eerste beschikbare datum voorselecteren.
    select(current || values[0], false, 'init');

    more.addEventListener('click', function () {
      expanded = true;
      render();
      highlight(input.value);
    });

    if (other) {
      other.min = toISO(first);
      other.max = toISO(last);
      other.addEventListener('change', function () {
        if (!other.value) return;
        var d = fromISO(other.value);
        if (!inRange(d)) {
          setHint('Kies een werkdag tussen ' + longValue(first) + ' en ' + longValue(last) + '.', true);
          return;
        }
        select(longValue(d), true, 'calendar');
      });
    }
  }

  function scan() {
    document.querySelectorAll('.vp-date-picker').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();